import { render, staticRenderFns } from "./Asset.vue?vue&type=template&id=6b458920&scoped=true&"
import script from "./Asset.vue?vue&type=script&lang=ts&"
export * from "./Asset.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b458920",
  null
  
)

export default component.exports